module.exports = __webpack_public_path__ + "img/bg-login.c8cceb7b.jpg";